function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { includes } from 'lodash';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import { genId } from '../../helpers/generator';
import Text from '../text';
import '../../helpers/polyfills/closest';

var Switch = function Switch(_ref) {
  var children = _ref.children,
      checked = _ref.checked,
      className = _ref.className,
      disabled = _ref.disabled,
      forceControl = _ref.forceControl,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? genId() : _ref$id,
      label = _ref.label,
      _onClick = _ref.onClick,
      value = _ref.value,
      others = _objectWithoutProperties(_ref, ["children", "checked", "className", "disabled", "forceControl", "id", "label", "onClick", "value"]);

  var _useState = useState(checked),
      _useState2 = _slicedToArray(_useState, 2),
      _checked = _useState2[0],
      setChecked = _useState2[1];

  var classes = classNames('switch is-checkradio', className, {
    'is-disabled': disabled
  });
  var fieldClasses = classNames('field is-tri', {
    'has-slice': className && includes(className, 'has-slice')
  });
  var isChecked = forceControl ? checked : _checked;
  var content = children || label;
  return React.createElement("div", {
    className: fieldClasses
  }, React.createElement("div", {
    className: classNames('control is-tri', {
      'is-disabled': disabled
    })
  }, React.createElement("input", _extends({
    className: classes,
    type: "checkbox"
  }, others, {
    value: value,
    id: id,
    disabled: disabled,
    name: id,
    checked: isChecked
  })), React.createElement("label", {
    htmlFor: id,
    className: className.match(/(has-slice)/g) && 'has-slice-content',
    onClick: function onClick(e) {
      if (e.target.closest('.slice-call-to-action') && className.match(/(has-slice)/g) || disabled) {
        return false;
      }

      if (!forceControl) {
        setChecked(!_checked);
      } // e.target.id = id


      e.target.value = value;
      e.target.checked = isChecked;
      _onClick && _onClick(e);
    }
  }, content && typeof content.valueOf() === 'string' ? React.createElement(Switch.Text, {
    content: content
  }) : content)));
};

Switch.propTypes = {
  children: PropTypes.any,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  forceControl: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.any
};
Switch.Text = Text;
export default withModifiers(Switch);